module.exports = new __parcel__URL__("no-perms-empty-state.969408f9.svg").toString();